// extracted by mini-css-extract-plugin
export var locationCard = "_cs-0";